import type {
  AnswerMap,
  ExitModalConfig,
  Page,
  Question,
} from "../context/questionnaire/types";
import { evaluateConditions } from "./questionnaire-helpers";

export function hasGatableExitModal(data: Question["data"]): boolean {
  const em = data.exit_modal;
  if (!em) return false;
  if (em.content_url && String(em.content_url).trim().length > 0) return true;
  if (em.body && String(em.body).trim().length > 0) return true;
  return false;
}

export type ExitModalGate = { config: ExitModalConfig; questionName: string };

/** Delphi may omit `name`; skip-set + session need a stable string key. */
function exitModalGateQuestionKey(
  q: Question,
  pageStartIndex: number,
  questionRefIndex: number
): string {
  const fromName = q.data.name?.trim();
  if (fromName) return fromName;
  const fromKey = q.data.answer_key?.trim();
  if (fromKey) return fromKey;
  return `__exit_modal__${pageStartIndex}_${questionRefIndex}`;
}

/**
 * First question on the page (in order) that is visible by conditions and has a usable exit_modal.
 */
export function getExitModalGateForPage(
  page: Page,
  questions: Question[],
  answers: AnswerMap
): ExitModalGate | null {
  for (const ref of page.questions) {
    const q = questions[ref.index];
    if (!q || !evaluateConditions(q, answers)) continue;
    if (!hasGatableExitModal(q.data)) continue;
    const cfg = q.data.exit_modal ?? null;
    if (!cfg) continue;
    return {
      config: cfg,
      questionName: exitModalGateQuestionKey(q, page.startIndex, ref.index),
    };
  }
  return null;
}

export function getExitModalForPage(
  page: Page,
  questions: Question[],
  answers: AnswerMap
): ExitModalConfig | null {
  return getExitModalGateForPage(page, questions, answers)?.config ?? null;
}
